export default "__VITE_ASSET__CEiooJif__"